(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('PricingMatrixDialogController', PricingMatrixDialogController);

    PricingMatrixDialogController.$inject = ['$state', '$scope', '$mdDialog', 'region', 'pricingMatrix', 'PricingMatrix', 'TaxCode', 'Lender', 'AlertService', 'Enum'];

    function PricingMatrixDialogController ($state, $scope, $mdDialog, region, pricingMatrix, PricingMatrix, TaxCode, Lender, AlertService, Enum) {
        // Initalize pricing matrix
        pricingMatrix.products.PRICING_PARAMETER = pricingMatrix.products.PRICING_PARAMETER || [];
        Enum.PricingParameterType.forEach(function(parameterType) {
            pricingMatrix.parameters[parameterType] = pricingMatrix.parameters[parameterType] || [];
        });

        // Define bound variables
        var vm = this;
        vm.region = region;
        vm.pricingMatrix = pricingMatrix;
        vm.taxCodes = TaxCode.query({size: 9999, provinceId: region.provinceId});
        vm.lenders = Lender.query({size: 9999, isPrivate: false});
        vm.productCategories = Enum.ProductCategory.filter(function(value) {
            return !['PRICING_PARAMETER','UTILITY','SPECIAL_REQUIREMENT'].includes(value);
        });
        vm.parameterTypes = Enum.PricingParameterType.map(function(parameterType) {
            return {
                name: parameterType,
                isDiscrete: parameterType === 'MULTI_UNIT' || parameterType === 'ACREAGE',
                isCurrency: parameterType === 'PROPERTY_VALUE'
            };
        });
        vm.tierProducts = vm.pricingMatrix.products.PRICING_PARAMETER.reduce(function(object, product) {
            object[product.productType] = product;
            return object;
        }, {});

        vm.specialRequirementsTaxCodeId = vm.pricingMatrix.specialRequirements["PRIVATE_LENDER"][0].taxCodeId;
        vm.specialRequirementsTaxCodeChanged = specialRequirementsTaxCodeChanged;

        // Set initial selected category or parameterType
        vm.currentItem = vm.parameterTypes[0];

        vm.catList = [];

        // when a category is selected, the name is added to catList and the template will render that category
        // this is because it takes forever to render all of the categories upfront.
        $scope.$watch('vm.currentItem', function() {
            if (vm.productCategories.includes(vm.currentItem)) {
                if (!vm.catList.includes(vm.currentItem)) {
                    vm.catList.push(vm.currentItem);
                }
            }
        });

        // "Set All" markup model per category section
        vm.sectionMarkups = {};

        // Snapshot original markup values from DB for revert support
        var originalMarkups = snapshotMarkups();

        // Define bound methods
        vm.cancel = cancel;
        vm.save = save;
        vm.addParameter = addParameter;
        vm.addSpecialRequirement = addSpecialRequirement;
        vm.applyMarkupToSection = applyMarkupToSection;
        vm.applyMarkupToTiers = applyMarkupToTiers;
        vm.applyMarkupToSpecialRequirements = applyMarkupToSpecialRequirements;
        vm.revertSectionMarkups = revertSectionMarkups;
        vm.revertTierMarkups = revertTierMarkups;
        vm.revertSpecialRequirementMarkups = revertSpecialRequirementMarkups;

        function cancel () {
            $mdDialog.cancel();
            $state.go('region', null);
        }

        function save () {
            vm.isSaving = true;
            PricingMatrix.update({id: vm.region.id}, vm.pricingMatrix).$promise.then(function(result) {
                $scope.$emit('valueconnectApp:pricingMatrixUpdate', result);
                AlertService.success("valueconnectApp.region.pricingMatrix.updated", { regionName: region.name});
                vm.pricingMatrix = result;
                originalMarkups = snapshotMarkups();
            }).catch(function(error) {
                var message = (error && error.data && error.data.description) || 'An error occurred while saving the pricing matrix.';
                AlertService.error(message);
            }).finally(function() {
                vm.isSaving = false;
            });
        }

        /**
         * Add a new parameter to the end of the specified array
         * @param {Array} array The array to add the parameter to
         */
        function addParameter(array) {
            array.push({
                manualQuote: false,
                excludedProducts: []
            });
        }

        /**
         * Add a new SpecialRequirement to the end of the specified array
         * @param {Array} array The array to add the SpecialRequirement to
         */
        function addSpecialRequirement(array) {
            array.push({
                specialRequirementType: 'PUBLIC_LENDER',
                regionId: vm.region.id,
                taxCodeId: vm.specialRequirementsTaxCodeId,
                manualQuote: false,
                excludedProducts: []
            });
        }

        /**
         * Apply a markup % to all products in a category section
         * @param {String} category The product category key
         * @param {Number} markupValue The markup % to set on all products
         */
        function applyMarkupToSection(category, markupValue) {
            if (markupValue == null || markupValue === '') return;
            var products = vm.pricingMatrix.products[category];
            if (!products) return;
            angular.forEach(products, function(product) {
                product.vcMarkupPercent = parseFloat(markupValue);
            });
        }

        /**
         * Apply a markup % to all tier rows in a parameter section and to the section's RegionalProduct
         */
        function applyMarkupToTiers(parameterTypeName, markupValue) {
            if (markupValue == null || markupValue === '') return;
            var parsed = parseFloat(markupValue);
            var tiers = vm.pricingMatrix.parameters[parameterTypeName];
            if (tiers) {
                angular.forEach(tiers, function(tier) {
                    tier.vcMarkupPercent = parsed;
                });
            }
            if (vm.tierProducts[parameterTypeName]) {
                vm.tierProducts[parameterTypeName].vcMarkupPercent = parsed;
            }
        }

        /**
         * Apply a markup % to all special requirement rows
         */
        function applyMarkupToSpecialRequirements(markupValue) {
            if (markupValue == null || markupValue === '') return;
            var parsed = parseFloat(markupValue);
            angular.forEach(vm.pricingMatrix.specialRequirements, function(specialRequirementList) {
                angular.forEach(specialRequirementList, function(sr) {
                    sr.vcMarkupPercent = parsed;
                });
            });
        }

        function snapshotMarkups() {
            var snapshot = { products: {}, parameters: {}, specialRequirements: {} };
            angular.forEach(vm.pricingMatrix.products, function(products, category) {
                snapshot.products[category] = products.map(function(p) { return p.vcMarkupPercent; });
            });
            angular.forEach(vm.pricingMatrix.parameters, function(tiers, paramType) {
                snapshot.parameters[paramType] = tiers.map(function(t) { return t.vcMarkupPercent; });
            });
            angular.forEach(vm.pricingMatrix.specialRequirements, function(srList, srType) {
                snapshot.specialRequirements[srType] = srList.map(function(sr) { return sr.vcMarkupPercent; });
            });
            return snapshot;
        }

        function revertSectionMarkups(category) {
            var products = vm.pricingMatrix.products[category];
            var saved = originalMarkups.products[category];
            if (!products || !saved) return;
            for (var i = 0; i < products.length && i < saved.length; i++) {
                products[i].vcMarkupPercent = saved[i];
            }
            vm.sectionMarkups[category] = null;
        }

        function revertTierMarkups(parameterTypeName) {
            var tiers = vm.pricingMatrix.parameters[parameterTypeName];
            var saved = originalMarkups.parameters[parameterTypeName];
            if (!tiers || !saved) return;
            for (var i = 0; i < tiers.length && i < saved.length; i++) {
                tiers[i].vcMarkupPercent = saved[i];
            }
            if (vm.tierProducts[parameterTypeName]) {
                var productsSaved = originalMarkups.products['PRICING_PARAMETER'];
                var products = vm.pricingMatrix.products['PRICING_PARAMETER'];
                if (productsSaved && products) {
                    for (var j = 0; j < products.length; j++) {
                        if (products[j].productType === parameterTypeName) {
                            products[j].vcMarkupPercent = productsSaved[j];
                            break;
                        }
                    }
                }
            }
            vm.sectionMarkups[parameterTypeName] = null;
        }

        function revertSpecialRequirementMarkups() {
            angular.forEach(vm.pricingMatrix.specialRequirements, function(srList, srType) {
                var saved = originalMarkups.specialRequirements[srType];
                if (!saved) return;
                for (var i = 0; i < srList.length && i < saved.length; i++) {
                    srList[i].vcMarkupPercent = saved[i];
                }
            });
            vm.sectionMarkups['SPECIAL_REQUIREMENTS'] = null;
        }

        function specialRequirementsTaxCodeChanged() {
            angular.forEach(vm.pricingMatrix.specialRequirements, function(specialRequirementType, key) {
                angular.forEach(specialRequirementType, function(specialRequirement) {
                    specialRequirement.taxCodeId = vm.specialRequirementsTaxCodeId;
                });
            });
        }
    }
})();
